export const PMS_LAB_FIRM = Object.freeze({
  id: "firm_harbour_legal_demo",
  name: "Harbour Legal (Demonstration)",
  shortName: "Harbour Legal",
  jurisdiction: "Victoria",
});

export const PMS_LAB_STAFF = Object.freeze([
  { id: "staff_emma", name: "Emma Lawson", role: "Principal solicitor", initials: "EL" },
  { id: "staff_noah", name: "Noah Williams", role: "Solicitor", initials: "NW" },
  { id: "staff_mia", name: "Mia Chen", role: "Practice manager", initials: "MC" },
]);

export const PMS_LAB_CLIENTS = Object.freeze([
  {
    id: "client_1001",
    clientNumber: "CL-1001",
    displayName: "Ava Morgan (Sample)",
    givenName: "Ava",
    familyName: "Morgan",
    dateOfBirth: "14 May 1992",
    email: "ava.morgan@example.test",
    phone: "0400 000 101",
    address: "12 Example Street, Carlton VIC 3053",
  },
  {
    id: "client_1002",
    clientNumber: "CL-1002",
    displayName: "Liam Patel (Sample)",
    givenName: "Liam",
    familyName: "Patel",
    dateOfBirth: "2 September 1986",
    email: "liam.patel@example.test",
    phone: "0400 000 102",
    address: "28 Demonstration Road, Footscray VIC 3011",
  },
  {
    id: "client_1003",
    clientNumber: "CL-1003",
    displayName: "Sofia Nguyen (Sample)",
    givenName: "Sofia",
    familyName: "Nguyen",
    dateOfBirth: "19 January 1998",
    email: "sofia.nguyen@example.test",
    phone: "0400 000 103",
    address: "7 Prototype Lane, Richmond VIC 3121",
  },
]);

export const PMS_LAB_MATTERS = Object.freeze([
  {
    id: "matter_2026_001",
    matterNumber: "HL-2026-001",
    clientId: "client_1001",
    title: "Morgan — criminal proceeding",
    description: "Summary proceeding listed for contest mention.",
    practiceArea: "Criminal law",
    status: "Open",
    stage: "Pre-hearing",
    priority: "High",
    responsibleStaffId: "staff_emma",
    openedDate: "18 July 2026",
    nextDate: "18 August 2026",
    court: "Melbourne Magistrates’ Court",
    parties: [
      { id: "party_001", name: "Ava Morgan (Sample)", relationship: "Client / accused" },
      { id: "party_002", name: "Director of Public Prosecutions", relationship: "Prosecution" },
    ],
    tasks: [
      { id: "task_001", title: "Confirm witness availability", due: "12 Aug 2026", assignee: "Noah Williams", status: "In progress" },
      { id: "task_002", title: "Prepare contest mention summary", due: "15 Aug 2026", assignee: "Emma Lawson", status: "Not started" },
    ],
    activity: [
      { id: "activity_001", date: "8 Aug 2026 · 9:42 am", actor: "Mia Chen", type: "Document", detail: "Uploaded fictional police brief index." },
      { id: "activity_002", date: "6 Aug 2026 · 3:18 pm", actor: "Noah Williams", type: "Note", detail: "Recorded sample conference outcome and follow-up tasks." },
      { id: "activity_003", date: "18 Jul 2026 · 10:05 am", actor: "Emma Lawson", type: "Matter", detail: "Opened matter from demonstration intake." },
    ],
  },
  {
    id: "matter_2026_002",
    matterNumber: "HL-2026-002",
    clientId: "client_1002",
    title: "Patel — intervention order response",
    description: "Respondent advice and appearance preparation.",
    practiceArea: "Intervention orders",
    status: "Open",
    stage: "Directions",
    priority: "Normal",
    responsibleStaffId: "staff_noah",
    openedDate: "27 July 2026",
    nextDate: "24 August 2026",
    court: "Sunshine Magistrates’ Court",
    parties: [
      { id: "party_003", name: "Liam Patel (Sample)", relationship: "Client / respondent" },
      { id: "party_004", name: "Jordan Taylor (Sample)", relationship: "Applicant" },
    ],
    tasks: [
      { id: "task_003", title: "Review proposed conditions", due: "17 Aug 2026", assignee: "Noah Williams", status: "Not started" },
    ],
    activity: [
      { id: "activity_004", date: "7 Aug 2026 · 11:20 am", actor: "Noah Williams", type: "Note", detail: "Added demonstration chronology." },
      { id: "activity_005", date: "27 Jul 2026 · 2:30 pm", actor: "Mia Chen", type: "Matter", detail: "Created matter and assigned responsible solicitor." },
    ],
  },
  {
    id: "matter_2026_003",
    matterNumber: "HL-2026-003",
    clientId: "client_1003",
    title: "Nguyen — legal aid advice",
    description: "Initial advice and legal-aid eligibility workflow.",
    practiceArea: "Legal aid",
    status: "Pending intake",
    stage: "Initial assessment",
    priority: "Normal",
    responsibleStaffId: "staff_emma",
    openedDate: "5 August 2026",
    nextDate: "Not listed",
    court: "Not allocated",
    parties: [{ id: "party_005", name: "Sofia Nguyen (Sample)", relationship: "Prospective client" }],
    tasks: [
      { id: "task_004", title: "Complete conflict review", due: "10 Aug 2026", assignee: "Emma Lawson", status: "In progress" },
      { id: "task_005", title: "Request proof of means", due: "11 Aug 2026", assignee: "Mia Chen", status: "Not started" },
    ],
    activity: [
      { id: "activity_006", date: "5 Aug 2026 · 4:10 pm", actor: "Mia Chen", type: "Intake", detail: "Created prospective-client record from demonstration intake." },
    ],
  },
]);

export function getPmsLabClient(clientId, clients = PMS_LAB_CLIENTS) {
  return clients.find((client) => client.id === clientId) ?? null;
}

export function getPmsLabStaff(staffId) {
  return PMS_LAB_STAFF.find((staff) => staff.id === staffId) ?? null;
}

export function searchPmsLabMatters(query, matters = PMS_LAB_MATTERS, clients = PMS_LAB_CLIENTS) {
  const normalizedQuery = String(query ?? "").trim().toLowerCase();
  if (!normalizedQuery) return matters;

  return matters.filter((matter) => {
    const client = getPmsLabClient(matter.clientId, clients);
    const searchable = [
      matter.matterNumber,
      matter.title,
      matter.practiceArea,
      matter.status,
      matter.court,
      client?.displayName,
      client?.clientNumber,
    ];
    return searchable.some((value) => String(value ?? "").toLowerCase().includes(normalizedQuery));
  });
}
